import React, {Component} from 'react';
import ClientPageBackButton from "./../ClientPageBackButton";
import ScrollToComponent from "./../ScrollToComponent";

import SwarovskiNaslovna from '../../images/sw-main.jpg';
import SWBlue from '../../images/sw-blue.jpg';

var SwarovskiNaslovnaImg = {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    height: '100vh',
    backgroundImage: `url(${SwarovskiNaslovna})`
};

var SWBlueImg = {
    backgroundSize: "cover",
    backgroundImage: `url(${SWBlue})`,
};


export default class SwarovskiPage extends Component {
    constructor(props) {
        super(props);
    }

    scrollNodes = [
        '#section1',
        '#section2',
        '#section3',
        '#section4',
        '#section5',
        '#section6',
        '#section7',
        '#section8',
        '#section9'
    ];

    render() {
        return (
            <div className="smart-page">
                <ClientPageBackButton parentThis={this} currentSlideGroup={2} path="/en" />
                <ScrollToComponent scrollNodes={this.scrollNodes}/>

                <div className="main-image-page" style={SwarovskiNaslovnaImg}>
                </div>
                <div id="section1">
                    <div className="top-image-cont" style={SWBlueImg}>
                        <img className="ekipa" src="/img/sw-blue-one.jpg" alt="swarovski logo smart agency"/>
                    </div>
                    <div id="section2" className="sw-blue-back-section">
                        <div className="sw-text-with-image">
                            <div className="left-side">
                                <div className="text">

                                    <p className="amatek-title">GROUNDBREAKING CEREMONY</p>
                                    <p className="amatek-first-text white-text">Every great dream begins with a significant first step. In economy, marketing, life...<br/>
                                    Smart Agency was the organizational support for the Swarovski company when it started building its great dream in Serbia.</p>
                                </div>
                                <img className="" src="/img/sw-slem.jpg" alt="swarovski logo smart agency"/>
                            </div>
                            <img className="right-side" src="/img/sw-blue-two.jpg" alt="swarovski kopanje"/>
                        </div>
                        <div id="section3" className="section-3-images">
                            <div className="image-section-3">
                                <img src="/img/sw-two-sec.jpg" alt=""/>
                                <div className="left-content">
                                    <img src="/img/sw-two-two.jpg" alt=""/>
                                    <div id="section4" className="sw-ceremony-text">
                                        <p className="amatek-title">OPENING CEREMONY</p>
                                        <p className="amatek-first-text white-text">Respectable guests both from the country and abroad, the media and wider public all followed the opening ceremony for the new Swarovski factory in Subotica. We were left with great impressions business-wise from the organization of this exquisite event.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="section5" className="section-4">
                            <img className="sw-cer-img" src="/img/sw-cer.jpg" alt=""/>
                        </div>
                        <section id="section6" className="sw-four">
                            <div className="top-image-container-holder">
                                <img src="/img/layer-36.png" alt=""/>
                                <img src="/img/layer-33.png" alt=""/>
                            </div>
                            <img className="top-min" src="/img/layer-34.jpg" alt=""/>
                        </section>

                        <section id="section7" className="sw-five">
                            <div className="sw-five-down">
                                <div className="cont-wrap">
                                    <div className="top-image-container">
                                        <img src="/img/layer-26.jpg" alt=""/>
                                        <div className="sw-family-right">
                                            <div className="family-text">
                                                <p className="amatek-title ">WORK IS FUN</p>
                                                <p className="amatek-first-text white-text">To us from the world of marketing – every day.<br/>
                                                And we also invested special effort in order to make the business environment for the employees of the Swarowski factory in Subotica and their families merry and fun.<br/>
                                                We devised and provided laughter, sport activities and fun games for the youngest, as part of the Family Day, with great pleasure.
                                                </p>
                                            </div>
                                            <img className="cont-bott-img" src="/img/layer-28.png" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="cleardiv"></div>
                        <img id="section8" src="/img/layer-29.jpg" alt=""/>
                        <img id="section9" src="/img/layer-31.jpg" alt=""/>
                    </div>

                </div>



            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/English/SwarowskiEnglishPage.js